/**
 * 보스 예약 주문(pack order) 관련 뮤테이션.
 * pre-order/sales, pre-order-list에서 재사용.
 */
import { gql } from "@apollo/client";

export const CONFIRM_PACK_ORDER = gql`
  mutation ConfirmPackOrder($orderId: Int!) {
    confirmPackOrder(orderId: $orderId) {
      id
      isPackConfirmed
    }
  }
`;

export const CANCEL_PACK_ORDER = gql`
  mutation CancelPackOrder($orderId: Int!, $cancelReason: String!) {
    cancelPackOrder(orderId: $orderId, cancelReason: $cancelReason) {
      ok
      error
    }
  }
`;
